import * as yup from 'yup';

// Phone number validation for UK format (+44 format)
const phoneRegExp = /^\+44\s?\d{10}$/;

export const registerSchema = yup.object({
  firstName: yup
    .string()
    .required('First Name is required')
    .min(2, 'First Name must be at least 2 characters long')
    .max(50, 'First Name must be less than 50 characters')
    .matches(/^[a-zA-Z\s\-']+$/, 'First Name can only contain letters, spaces, hyphens, and apostrophes')
    .trim()
    .test('no-leading-trailing-spaces', 'First Name cannot have leading or trailing spaces',
      value => value === value?.trim()),

  lastName: yup
    .string()
    .required('Last Name is required')
    .min(2, 'Last Name must be at least 2 characters long')
    .max(50, 'Last Name must be less than 50 characters')
    .matches(/^[a-zA-Z\s\-']+$/, 'Last Name can only contain letters, spaces, hyphens, and apostrophes')
    .trim()
    .test('no-leading-trailing-spaces', 'Last Name cannot have leading or trailing spaces',
      value => value === value?.trim()),

  email: yup
    .string()
    .required('Email is required')
    .email('Please enter a valid email address')
    .trim()
    .test('no-leading-trailing-spaces', 'Email cannot have leading or trailing spaces',
      value => value === value?.trim()),

  phone: yup
    .string()
    .required('Phone number is required')
    .matches(phoneRegExp, 'Phone number must be in UK format: +44 7873 611 111')
    .test('no-leading-trailing-spaces', 'Phone number cannot have leading or trailing spaces',
      value => value === value?.trim()),

  password: yup
    .string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters long')
    .matches(/[a-z]/, 'Password must contain a lowercase letter')
    .matches(/[A-Z]/, 'Password must contain an uppercase letter')
    .matches(/\d/, 'Password must contain a number')
    .matches(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/? ]/, 'Password must contain a special character or space')
    .test('no-leading-trailing-spaces', 'Password cannot have leading or trailing spaces',
      value => value === value?.trim()),

  confirmPassword: yup
    .string()
    .required('Please confirm your password')
    .oneOf([yup.ref('password')], 'Passwords must match'),
});

export type RegisterFormData = yup.InferType<typeof registerSchema>;

// Helper function to format phone number for display
export const formatPhoneNumber = (phone: string): string => {
  if (!phone) return '';

  const cleaned = phone.replace(/[\s\-]/g, '');

  if (cleaned.startsWith('+44')) {
    const numberPart = cleaned.substring(3);
    if (numberPart.length === 10) {
      return `+44 ${numberPart.substring(0, 4)} ${numberPart.substring(4, 7)} ${numberPart.substring(7)}`;
    }
  }

  return phone;
};

// Helper function to clean phone number for API (remove spaces)
export const cleanPhoneNumber = (phone: string): string => {
  return phone ? phone.replace(/[\s\-]/g, '') : '';
}; 